.details-toggle {
  padding: 0;
  margin-top: var(--mantine-spacing-md);
  font-size: var(--mantine-font-size-sm);
  color: var(--mantine-color-blue-6);
  text-decoration: underline;
  cursor: pointer;
  background: none;
  border: none;
}

.details-toggle:hover {
  color: var(--mantine-color-blue-7);
}

.details-content {
  padding: var(--mantine-spacing-xs);
  margin-top: var(--mantine-spacing-xs);
  overflow-x: auto;
  font-family: var(--mantine-font-family-monospace);
  font-size: var(--mantine-font-size-xs);
  color: var(--mantine-color-gray-4);
  word-break: break-all;
  white-space: pre-wrap;
  background: var(--mantine-color-dark-6);
  border-radius: var(--mantine-radius-sm);
}

.inline {
  padding: var(--mantine-spacing-md);
  color: var(--mantine-color-red-6);
}

.inline-title {
  font-weight: calc(var(--mantine-heading-font-weight) * 0.857);
}

.inline-message {
  margin-top: var(--mantine-spacing-xs);
  font-size: var(--mantine-font-size-sm);
  color: var(--mantine-color-gray-5);
}

.minimal {
  display: inline;
  color: inherit;
}
